import { useState } from "react";
import {
  TextField,
  Grid,
  Typography,
  Button,
  CircularProgress,
  Checkbox,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { signUp } from "../redux/slices/authenticationSlice";
import { Box, Stack } from "@mui/system";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import colaBg2 from "../assets/cc-logo-3.png";
import RulesModal from "../components/RulesModal";
// import Parse from "parse/dist/parse.min.js";
// Your Parse initialization configuration goes here
// const PARSE_APPLICATION_ID = "VqIbpuRJ7gqgb7NkxZ8mUwzlhpqE0EZRDchIZDoq";
// const PARSE_HOST_URL = "https://parseapi.back4app.com/";
// const PARSE_JAVASCRIPT_KEY = "bW0WTXF1V8OUiLsKbYZdNvmk2qduUgzDfVBvc5HG";
// Parse.initialize(PARSE_APPLICATION_ID, PARSE_JAVASCRIPT_KEY);
// Parse.serverURL = PARSE_HOST_URL;

const SignupForm = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [openRulesModal, setOpenRulesModal] = useState(false);

  const onTermsAccepted = (event) => {
    setTermsAccepted(event.target.checked);
  };
  const signUpUserLoading = useSelector(
    (state) => state.authentication.signUpUserLoading
  );
  const signUpUserError = useSelector(
    (state) => state.authentication.signUpUserError
  );

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePhoneNumberChange = (event) => {
    setPhone(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const hanleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const isEmailValid = () => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const isPhoneNumberValid = () => {
    return /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(phone);
    // return /^[0-9]{10}$/.test(phone);
  };

  const isPasswordValid = () => {
    return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(password);
  };

  const isConfirmPasswordValid = () => {
    return password === confirmPassword;
  };

  const onSignUp = () => {
    dispatch(signUp({ username, password, email, phone })).then(
      (response) => {
        navigate("/login");
      },
      (err) => {
        console.log(err);
      }
    );
  };
  const isFormValid = () => {
    const allFieldsValid =
      termsAccepted &&
      username &&
      password &&
      confirmPassword &&
      email &&
      isPasswordValid() &&
      isConfirmPasswordValid() &&
      isEmailValid();
    if (phone) {
      return allFieldsValid && isPhoneNumberValid();
    } else {
      return allFieldsValid;
    }
  };

  return (
    <div
      style={{
        background: `url(${colaBg2}) no-repeat center bottom`,
        backgroundSize: "cover",
        height: "100vh",
        maxWidth: "800px",
        margin: "auto",
      }}
    >
      <div
        style={{
          maxWidth: "500px",
          margin: "auto",
          padding: "12px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "80%%",
        }}
      >
        <div className="companyName">{t("signUp.signUp")}</div>
        <form
          onSubmit={handleSubmit}
          style={{
            backgroundColor: "#ffffffc2",
            marginTop: "24px",
            borderRadius: "5%",
          }}
        >
          <Grid container spacing={2} padding={2}>
            <Grid item xs={12}>
              <TextField
                id="username"
                label={t("signUp.username")}
                type="text"
                value={username}
                onChange={hanleUsernameChange}
                fullWidth
                required
                // error={!isPasswordValid() && password !== ""}
                // helperText={
                //   !isPasswordValid() && password !== ""
                //     ? "Password must contain at least 8 characters including one letter and one number"
                //     : ""
                // }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="password"
                label={t("signUp.password")}
                type="password"
                value={password}
                onChange={handlePasswordChange}
                fullWidth
                required
                error={!isPasswordValid() && password !== ""}
                helperText={
                  !isPasswordValid() && password !== ""
                    ? t("signUp.passwordConstraint")
                    : ""
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="confirmPassword"
                label={t("signUp.confirmPassword")}
                type="password"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                fullWidth
                required
                error={!isConfirmPasswordValid() && confirmPassword !== ""}
                helperText={
                  !isConfirmPasswordValid() && confirmPassword !== ""
                    ? t("signUp.passwordsNotMatchConstraint")
                    : ""
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="email"
                label={t("signUp.email")}
                type="email"
                value={email}
                onChange={handleEmailChange}
                fullWidth
                required
                error={!isEmailValid() && email !== ""}
                helperText={!isEmailValid() && email !== "" ? "" : ""}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="phone"
                label="Phone Number"
                type="tel"
                value={phone}
                onChange={handlePhoneNumberChange}
                fullWidth
                error={!isPhoneNumberValid() && phone !== ""}
                helperText={
                  !isPhoneNumberValid() && phone !== ""
                    ? t("signUp.phoneNumberValidConstraint")
                    : ""
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Stack
                display="flex"
                direction="row"
                alignItems="center"
                sx={{ marginLeft: "-12px" }}
              >
                <Checkbox checked={termsAccepted} onChange={onTermsAccepted} />
                <Typography component="div" marginRight="8px">
                  {t("signUp.accept")}
                </Typography>
                <Link onClick={() => setOpenRulesModal(true)}>
                  {t("signUp.termsAndConditions")}
                </Link>
              </Stack>
            </Grid>
            {signUpUserError && (
              <Grid item xs={12} textAlign="center">
                <Typography variant="body" color="error">
                  {t("errors." + signUpUserError.code)}
                </Typography>
              </Grid>
            )}
            <Grid item xs={12}>
              <Button
                disabled={!isFormValid()}
                variant="contained"
                color="error"
                type="submit"
                fullWidth
                onClick={onSignUp}
              >
                {signUpUserLoading === "PENDING" ? (
                  <Box sx={{ display: "flex" }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  t("signUp.signUp")
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          marginTop="12px"
          paddingBottom="24px"
        >
          <Link style={{ color: "white" }} to="/login">
            {t("signUp.backToLogin")}
          </Link>
        </Stack>
        {/* <Box
          component="div"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "30vh",
          }}
        >
          <Container
            sx={{
              width: "200px",
              height: "100px",
              borderRadius: "10%",
              background: "#FFFFFF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={ccLogo} width="150px" alt="logo" />
          </Container>
        </Box> */}
        {openRulesModal && (
          <RulesModal
            open={openRulesModal}
            onClose={() => setOpenRulesModal(false)}
          />
        )}
      </div>
    </div>
  );
};
export default SignupForm;
